import React from 'react'

const NavBar = () => {
    return (
        <div>
            <nav className="navBar">
                <a href="localhost" className="navBar__Brand">Movie APP</a>
            </nav>
        </div>
    )
}

export default NavBar